export const NAV_HEIGHT = 75;
export const CHECKLIST_DRAWER_WIDTH = 460;
export const CHECKLIST_DRAWER_Z_INDEX = 7500;
